// extracted by mini-css-extract-plugin
export default {"page-footer":"Footer_page-footer__1uaPM"};